import axios, { client2 } from "@/config/axios-wrapper";

export const userLogin = async (data) => {
  return await client2.post("/users/login", data);
};

export const employerSignUp = async (data) => {
  return await axios.post("/organizations", data);
};

export const forgotPass = async (data) => {
  return await axios.post("/users/forgot-password", data);
};

export const resendEmail = async (data) => {
  return await axios.post("/users/email-verification/resend-email", data);
};

export const refreshTokenApi = async (data: { refresh_token: string }) => {
  const response = await axios.post<{ access_token: string }>("/auth/refreshToken", data);
  return response.data;
};

// jobSeeker Auth screens
export const jobSeekerSignUp = async (data) => {
  return await axios.post("/users/register", data);
};

export const linkedinAccesstoken = async (data) => {
  return await axios.post("/auth/linkedin/accessToken", data);
};

export const jobSeekerRegister = async (data) => {
  return await client2.post("/jobseekers/register", data);
};